import VerticalDefault from "../../layouts/vertical-default/VerticalDefault";
import SoloPage from "../../layouts/solo-page/SoloPage";
import PrivatePage from "app/layouts/private/PrivatePage";
import PublicPage from "app/layouts/public/PublicPage";

const LAYOUT_NAMES = {
    VERTICAL_DEFAULT: "vertical-default",
    SOLO_PAGE: "solo-page",
    PRIVATE_PAGE: "private-page",
    PUBLIC_PAGE: "public-page",
};

const LAYOUTS = [
    {
        name: LAYOUT_NAMES.VERTICAL_DEFAULT,
        label: "Vertical Default",
        component: VerticalDefault,
    },
    {
        name: LAYOUT_NAMES.SOLO_PAGE,
        label: "Solo Page",
        component: SoloPage
    },
    {
        name: LAYOUT_NAMES.PRIVATE_PAGE,
        label: "Private Page",
        component: PrivatePage
    },
    {
        name: LAYOUT_NAMES.PUBLIC_PAGE,
        label: "Public Page",
        component: PublicPage
    },
];

export {LAYOUTS, LAYOUT_NAMES};